import { Box } from '@mui/material';

const AuthBackground = () => (
  <Box
    sx={{
      position: 'absolute',
      top: '65%',
      filter: 'blur(18px)',
      zIndex: -1,
      left: '40%',
      transform: 'translate(-50%, -50%)',
      width: '100%',
      height: '100%',
      overflow: 'hidden'
    }}
  >
    <img src="/assets/images/logo/cw-logo.png" alt="Logo" height="75%" />
  </Box>
);

export default AuthBackground;
